import { AlreadyPaidOptions, IGetPolicyPaymentInfoResponse } from './types';
import { createGlobalState } from 'react-hooks-global-state';
import { ClubHelper } from '@ace-clublabs/payments-helper';
import { ClubCodes, BrokerRegion } from '@ace-clublabs/payment-types';
import CookieHelper from '../utils/cookieHelper';
import { AppFlow } from '@lib/web-shared';

type State = {
  policyPaymentInfo?: IGetPolicyPaymentInfoResponse;
  policyNumber: string;
  amountChosen: number | undefined;
  paymentPlan?: string;
  primaryEmail?: string;
  secondaryEmail?: string;
  transactionId: string;
  transactionProductPrefix?: string;
  allowedClubs: string[];
  clubCode: string;
  selectedAutoPay?: boolean;
  clubTag: string;
  startPath: string;
  alreadyPaidOption: AlreadyPaidOptions | undefined;
  policyMetaData?: any;
  appFlow?: AppFlow;
  isMobileApp: boolean;
  queryProps: any;
  inMaintenance: boolean;
  brokerRegion?: BrokerRegion;
};

const initialState: State = {
  policyPaymentInfo: undefined,
  policyNumber: '',
  amountChosen: undefined,
  paymentPlan: '',
  primaryEmail: undefined,
  secondaryEmail: undefined,
  transactionId: '',
  transactionProductPrefix: undefined,
  allowedClubs: [],
  clubCode: '',
  startPath: '',
  selectedAutoPay: undefined,
  clubTag: '',
  alreadyPaidOption: undefined,
  policyMetaData: undefined,
  appFlow: AppFlow.PAYMENT,
  isMobileApp: false,
  queryProps: {},
  inMaintenance: false,
  brokerRegion: undefined,
};

export const createInitialState = (): State => {
  const sessionStateString = sessionStorage.getItem('insurancePwolState') || '{}';
  const sessionState = JSON.parse(sessionStateString);
  const clubTag = ClubHelper.getClubAcronym(CookieHelper.getClubCodeFromZipcodeCookie() as ClubCodes);
  const state = { ...initialState, clubTag, ...sessionState };
  return state;
};

export const createEmptyInitialState = (): State => {
  const clubTag = ClubHelper.getClubAcronym(CookieHelper.getClubCodeFromZipcodeCookie() as ClubCodes);
  const state = { ...initialState, clubTag };
  return state;
};

export const { useGlobalState, setGlobalState } = createGlobalState<State>(createInitialState());
